import {
	SET_ERROR,
	CORE_AUTH_VERIFY_SUCCESS,
	CORE_AUTH_VERIFY_FAILURE,

	CORE_GET_ALL_TABLE_REQUEST,
	CORE_GET_ALL_TABLE_SUCCESS,
	CORE_GET_ALL_TABLE_FAILURE,

	CORE_GET_TABLE_BY_ID_REQUEST,
	CORE_GET_TABLE_BY_ID_SUCCESS,
	CORE_GET_TABLE_BY_ID_FAILURE,

	CORE_SET_WORKER_REQUEST,
	CORE_SET_WORKER_SUCCESS,
	CORE_SET_WORKER_FAILURE,

	CORE_SET_START_TIME_REQUEST,
	CORE_SET_START_TIME_SUCCESS,
	CORE_SET_START_TIME_FAILURE,

	CORE_SET_END_TIME_REQUEST,
	CORE_SET_END_TIME_SUCCESS,
	CORE_SET_END_TIME_FAILURE,

	CORE_TASK_ON_JOB_REQUEST,
	CORE_TASK_ON_JOB_SUCCESS,
	CORE_TASK_ON_JOB_FAILURE,

	CORE_REPORT_AS_FINISHED_DATAS_REQUEST,
	CORE_REPORT_AS_FINISHED_DATAS_SUCCESS,
	CORE_REPORT_AS_FINISHED_DATAS_FAILURE,

	CORE_LOAD_RESOURCES_REQUEST,
	CORE_LOAD_RESOURCES_SUCCESS,
	CORE_LOAD_RESOURCES_FAILURE,

	CORE_LOAD_WAREHOUSES_REQUEST,
	CORE_LOAD_WAREHOUSES_SUCCESS,
	CORE_LOAD_WAREHOUSES_FAILURE,

	CORE_LOAD_SCRAPS_REQUEST,
	CORE_LOAD_SCRAPS_SUCCESS,
	CORE_LOAD_SCRAPS_FAILURE,


	CORE_MANAGER_VERIFY_REQUEST,
	CORE_MANAGER_VERIFY_SUCCESS,
	CORE_MANAGER_VERIFY_FAILURE,

	CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST,
	CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS,
	CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE,
} from '../types'


const initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
}
	, initialStateArray = []


export default {
	errorList: (state = initialStateArray, action) => {
		switch (action.type) {
			case SET_ERROR:
				let newError = []
				if (action && Array.isArray(action.error)) {
					newError = action.error
				}
				return newError

			case CORE_AUTH_VERIFY_SUCCESS:
			case CORE_MANAGER_VERIFY_SUCCESS:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { errors, result } = action.payload
					const { url } = action
					let newError = []
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(e => {
								const { path, code, message } = e
								return newError.push({ code, message, isShow: true, path, url, isFromAction: true })
							})
						}
						else newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url, isFromAction: true })
					}

					return newError
				}
				return state

			case CORE_AUTH_VERIFY_FAILURE:
			case CORE_MANAGER_VERIFY_FAILURE:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { code, message, statusText, statusCode } = action.payload
					const { url } = action
					let newError = []

					newError.push({
						code: code ? code : "404",
						message,
						isShow: false,
						statusText,
						statusCode,
						url
					})

					return newError
				}
				return state
			default:
				return state
		}
	},
	isLoading: (state = false, action) => {
		switch (action.type) {
			// case CORE_GET_TRANSFER_BY_ID_REQUEST:
			case CORE_GET_ALL_TABLE_REQUEST:
			case CORE_GET_TABLE_BY_ID_REQUEST:
			case CORE_SET_WORKER_REQUEST:
			case CORE_SET_START_TIME_REQUEST:
			case CORE_SET_END_TIME_REQUEST:
			case CORE_TASK_ON_JOB_REQUEST:
			case CORE_REPORT_AS_FINISHED_DATAS_REQUEST:
			case CORE_LOAD_RESOURCES_REQUEST:
			case CORE_LOAD_WAREHOUSES_REQUEST:
			case CORE_LOAD_SCRAPS_REQUEST:
			case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST:
				return true
			// case CORE_GET_TRANSFER_BY_ID_SUCCESS:
			case CORE_GET_ALL_TABLE_SUCCESS:
			case CORE_GET_TABLE_BY_ID_SUCCESS:
			case CORE_SET_WORKER_SUCCESS:
			case CORE_SET_START_TIME_SUCCESS:
			case CORE_SET_END_TIME_SUCCESS:
			case CORE_TASK_ON_JOB_SUCCESS:
			case CORE_REPORT_AS_FINISHED_DATAS_SUCCESS:
			case CORE_LOAD_RESOURCES_SUCCESS:
			case CORE_LOAD_WAREHOUSES_SUCCESS:
			case CORE_LOAD_SCRAPS_SUCCESS:
			case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS:
				return false
			// case CORE_GET_TRANSFER_BY_ID_FAILURE:
			case CORE_GET_ALL_TABLE_FAILURE:
			case CORE_GET_TABLE_BY_ID_FAILURE:
			case CORE_SET_WORKER_FAILURE:
			case CORE_SET_START_TIME_FAILURE:
			case CORE_SET_END_TIME_FAILURE:
			case CORE_TASK_ON_JOB_FAILURE:
			case CORE_REPORT_AS_FINISHED_DATAS_FAILURE:
			case CORE_LOAD_RESOURCES_FAILURE:
			case CORE_LOAD_WAREHOUSES_FAILURE:
			case CORE_LOAD_SCRAPS_FAILURE:
			case CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE:
				return false
			default:
				return state
		}

	},
	reducerCallAPI: (state = initialStateCallAPI, action) => {
		switch (action.type) {

			default:
				return state
		}
	},

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js